import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-semibold transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 active:translate-x-0.5 active:translate-y-0.5",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-[3px_3px_0_rgba(30,64,175,0.5)] hover:shadow-[4px_4px_0_rgba(30,64,175,0.5)] hover:-translate-x-0.5 hover:-translate-y-0.5 active:shadow-[1px_1px_0_rgba(30,64,175,0.5)] border-2 border-primary",
        destructive:
          "bg-destructive text-destructive-foreground shadow-[3px_3px_0_rgba(127,29,29,0.5)] hover:shadow-[4px_4px_0_rgba(127,29,29,0.5)] hover:-translate-x-0.5 hover:-translate-y-0.5 active:shadow-[1px_1px_0_rgba(127,29,29,0.5)] border-2 border-red-700",
        outline:
          "border-2 border-primary/50 text-primary shadow-[2px_2px_0_rgba(59,130,246,0.2)] hover:shadow-[3px_3px_0_rgba(59,130,246,0.3)] hover:bg-primary/10 hover:-translate-x-0.5 hover:-translate-y-0.5",
        secondary:
          "bg-secondary/20 text-secondary border-2 border-secondary/50 shadow-[2px_2px_0_rgba(6,182,212,0.3)] hover:shadow-[3px_3px_0_rgba(6,182,212,0.4)] hover:-translate-x-0.5 hover:-translate-y-0.5",
        ghost: "hover:bg-primary/10 hover:text-primary border-2 border-transparent hover:border-primary/30",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-12 rounded-lg px-8 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
